export function detectTemplateVariables(content: string): string[] {
  if (!content) return [];

  const regex = /\{\{([a-zA-Z_][a-zA-Z0-9_]*)\}\}/g;
  const matches: string[] = [];
  let match;

  while ((match = regex.exec(content)) !== null) {
    const varName = match[1];
    if (!matches.includes(varName)) {
      matches.push(varName);
    }
  }

  return matches.sort();
}

export function detectPromptPlaceholders(content: string): string[] {
  if (!content) return [];

  // Single-brace {name} tokens (Bedrock prompt convention); {{name}} agent variables excluded.
  const regex = /(?<!\{)\{([a-zA-Z_][a-zA-Z0-9_]*)\}(?!\})/g;
  const matches: string[] = [];
  let match;

  while ((match = regex.exec(content)) !== null) {
    if (!matches.includes(match[1])) {
      matches.push(match[1]);
    }
  }

  return matches;
}

export function validateBalancedBraces(content: string): string | null {
  if (!content) return null;

  const openBraces = (content.match(/\{\{/g) || []).length;
  const closeBraces = (content.match(/\}\}/g) || []).length;

  if (openBraces !== closeBraces) {
    return "Template variables must be properly closed with }}";
  }

  const emptyVars = content.match(/\{\{\s*\}\}/g);
  if (emptyVars) {
    return "Empty template variables {{}} are not allowed";
  }

  const incompletePattern = /\{\{[^}]*\{\{/g;
  if (incompletePattern.test(content)) {
    return "Template variables must be properly closed with }}";
  }

  return null;
}

export function getContentValidationError(content: string): string | null {
  if (!content || content.trim() === '') {
    return "Content is required";
  }

  if (content.length > 50000) {
    return "Content must be 50,000 characters or less";
  }

  const braceError = validateBalancedBraces(content);
  if (braceError) {
    return braceError;
  }

  return null;
}

export function slugifyPromptName(title: string, type?: string): string {
  const separator = type === 'skill' ? '-' : '_';
  const maxLen = type === 'skill' ? 64 : 100;
  return title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, separator)
    .replace(new RegExp(`^\\${separator}|\\${separator}$`, 'g'), '')
    .slice(0, maxLen);
}

export function formatPublishedVersion(promptVersion?: string): string {
  if (!promptVersion || promptVersion === 'DRAFT') return 'Unpublished';
  return `Published v${promptVersion}`;
}
